<!--
 * @Author: your name
 * @Date: 2020-08-13 09:36:16
 * @LastEditTime: 2022-11-15 15:24:57
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/venue-group/index.vue
-->
<style scoped lang="sass">
.app_container
  height: 100%

  .head
    position: relative
    display: flex
    flex-direction: column
    align-items: center
    height: 153px
    margin-bottom: 20px
    box-shadow: 0px 2px 6px rgba(51,68,85,0.08)
    background-color: #fff

    .logo
      margin-top: 10px
      height: 71px

    .title
      margin-top: 13px
      font-size: 16px
      line-height: 16px
      font-weight: bold
      line-height: 19px
      color: rgba(51,68,85,1)

    .text
      margin-top: 7px
      font-size: 12px
      line-height: 14px
      color: rgba(51,68,85,1)

  .body
    flex: 1
    overflow-y: auto
    display: flex
    flex-direction: column
    align-items: center
    padding: 0  16px 20px 16px
    background-color: #fff

    ::v-deep
      .dishes_list
        height: 70px

      .infos_border
        border: none
</style>

<style lang="sass" scoped>
.icon
  flex: 1
  display: flex
  justify-content: center
  align-items: center

.pic
  height: 150px
  width: 150px
</style>

<template lang="pug">
.app_container
  .head
    img.logo(:src="logo")
    span.title Welcome to {{ venueGroupName }}
    p.text To begin an order, select one of our venues below
  .body(v-if="venueList.length > 0")
    dishes-list.p(
      v-for="item in venueList"
      :imgUrl="item.logo"
      :key="item.id"
      :name="item.name"
      :openHours="getOperationHours(item)"
      :type="1"
      :maskDisplay="!getVenueOpenTime(item)"
      :venue-group-disabled="!getVenueOpenTime(item)"
      @choose="jumpToVenue(item.id)"
    )
  .icon(v-if="venueList.length === 0 && !showLoading")
    svg-icon.pic(
      :color="color"
      icon-class="No_venues-01"
    )
</template>

<script>
import dayjs from 'dayjs'
import Vue from 'vue'
import Component from 'vue-class-component'
import { getVenueGroup } from 'api/product'
import { _getNowOperatingHours, _weeklyOperatingHours } from 'utils'

@Component({
  props: {
    venueGroupId: String
  },
  created() {
    this.$store.commit('showLoading')
    this.getData()
  },
  computed: {
    showLoading () {
      return this.$store.state.showLoading
    },
  }
})
class VenueList extends Vue {
  color = 'rgba(20, 196, 188, 1)'
  venueGroupType = 'normal'
  number = 1
  venueGroupName = ''
  venueList = []
  logo = ''

  async getData() {
    const res = await getVenueGroup({
      id: this.venueGroupId,
      type: this.venueGroupType
    }).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    this.$store.commit('closeLoading')
    this.venueList = res.venues
    this.logo = res.logo
    this.venueGroupName = res.name
  }

  jumpToVenue(id) {
    this.chooseVenueId = id
    // this.$router.push(`/v/${this.chooseVenueId}/home/t/${this.number}`)
    this.$router.push(`/v/${this.chooseVenueId}/home/p`)
  }

  _getTime(hour) {
    if (hour && ((hour.fromHour && hour.toHour) || hour?.hourSettings?.length)) {
      try {
        const [fromHour, fromMin] = hour.fromHour.split(':')
        const [toHour, toMin] = hour.toHour.split(':')
        return [fromHour, fromMin, toHour, toMin]
      } catch {
        return false
      }
    }
  }

  getOperationHours(data) {
    const { todayOperatingHours, weeklyOperatingHours } = data
    const closeText = 'not set open time yet'
    // 没有匹配到营业时间段，就展示闭店的文案
    if (!this._getTime(todayOperatingHours)) return closeText
    if (todayOperatingHours?.hourSettings?.length) {
      // 有 hourSettings 时，用多段时间的方法判断
      const time = _weeklyOperatingHours(weeklyOperatingHours, false, 0, true)
      return time || closeText
    } else {
      // 没有 hourSettings 时，用旧的单段时间的方法判断
      const [fromHour, fromMin, toHour, ToMin] = this._getTime(todayOperatingHours)
      const from = dayjs(`2019-01-25 ${fromHour}:${fromMin}`).format('hh:mma')
      const to = dayjs(`2019-01-25 ${toHour}:${ToMin}`).format('hh:mma')
      return from + ' - ' + to
    }
  }

  getVenueOpenTime(dateInfo) {
    // 餐厅是否营业的开关
    const { enable } = { ...dateInfo.todayOperatingHours }
    // 餐厅是否在营业时间
    const timeOver = dateInfo.todayOperatingHours ? !!_getNowOperatingHours(dateInfo.todayOperatingHours) : false
    return enable && timeOver
  }
}
export default VenueList
</script>
